import {NgModule} from '@angular/core';
import {PrimaryBulletComponent} from './primary-bullet/primary-bullet.component';
import {CommonModule} from '@angular/common';


@NgModule({
  imports: [CommonModule],
  exports: [PrimaryBulletComponent],
  declarations: [PrimaryBulletComponent],
  providers: [],
})
export class BulletModule {
}
